import React, { useEffect, useState } from "react";
import './oldGold.scss';
import Table from './table';
import { Camera, ChevronLeft, Edit, Printer, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { createOldGold, GetGoldRate, GetOldGoldList } from "../../services/oldGold";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { CustomLoader } from "../Loader";
import CustomModal from "../customModal";
import CameraCapture from "../cameraOption";
import ImageViewer from "../customModal/imageViewer";
const OldPurchaseEstimation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const userData = useSelector((state) => state.user);
  const selectedStore = useSelector((state) => state.nearbyStore.selectedStore);
  const [goldRate, setGoldRate] = useState([]);
  const [active_old_gold, setActive_old_gold] = useState('');

  const [formData, setFormData] = useState({
    productOrigin: '',
    invoiceNo: '',
    group: '',
    productSection: '',
    productDescription: '',
    hallmark: false,
    purity: "24KT",
    machCalcPurity: '',
    grossInfo: '',
    metalInfo: '',
    otherInfo: '', grossAmount: "",
    metalAmount: "",
    otherAmount: "",
    stoneAmount: "",
    stoneInfo: '',
    machCalcDepreWt: '',
    depreciatedWeight: '',
    netWtAfDepre: '',
    dealloyingCharge: '',
    dealloyingChargeAmount: '',
    handlingCharge: '',
    handlingChargeAmount: '',
    rateDeduction: '',
    rateDeductionAmount: '',
    rateDedAmountPerGram: '',
    rateBeforeDeduction: '',
    rateAfterDeduction: '',
    totalBeforeRateDeduction: '',
    rateDeductionTotal: '',
    total: '',
    grossAmount: "",
    metalAmount: "",
    otherAmount: "",
    stoneAmount: "",
    old_gold_before_melting: '',
    old_gold_after_melting: '',
  });
  const [products, setProducts] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [photo, setPhoto] = useState(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;


    if (name === "purity") {
      let currentGoldRate = matchKaratPurity(value);
      console.log(currentGoldRate, "matchedKarat");
      setFormData((prev) => ({
        ...prev,
        purity: value,
        rateBeforeDeduction: currentGoldRate?.price_per_gram,
      }));

    }


    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));



  };

  const handleEdit = (index) => {
    setFormData(products[index]);
    setEditIndex(index);
  };

  const handleAdd = () => {

    if (!userData?.isUser) {
      toast.warning("Please log in with a valid customer ID before continuing.");
      return
    }
    const emptyFields = [];

    if (!formData.productOrigin) emptyFields.push("Product Origin");
    if (!formData.productSection) emptyFields.push("Product Section");
    if (!formData.purity) emptyFields.push("Purity");
    if (!formData.metalInfo) emptyFields.push("Metal Info");

    if (emptyFields.length === 4) {
      toast.warn("Please fill in at least one of the required fields: Product Origin, Product Section, Purity, or Metal Info.");
      return;
    }

    if (emptyFields.length > 0) {
      toast.warn(`The following fields are empty: ${emptyFields.join(", ")}`);
      return
    }

    if (editIndex !== null) {
      // Editing existing item
      const updated = [...products];
      updated[editIndex] = formData;
      setProducts(updated);
      setEditIndex(null); // exit edit mode
    } else {
      // Adding new item
      setProducts((prev) => [...prev, formData]);
    }

    // Clear form
    setFormData({
      productOrigin: '',
      invoiceNo: '',
      group: '',
      productSection: '',
      productDescription: '',
      hallmark: false,
      purity: '',
      machCalcPurity: '',
      grossInfo: '',
      metalInfo: '',
      otherInfo: '',
      stoneInfo: '',
      machCalcDepreWt: '',
      depreciatedWeight: '',
      netWtAfDepre: '',
      dealloyingCharge: '0%',
      dealloyingChargeAmount: '',
      handlingCharge: '0%',
      handlingChargeAmount: '',
      rateDeduction: '0%',
      rateDeductionAmount: '',
      rateDedAmountPerGram: '',
      rateBeforeDeduction: '',
      rateAfterDeduction: '',
      totalBeforeRateDeduction: '',
      rateDeductionTotal: '',
      total: '',
      grossAmount: "",
      metalAmount: "",
      otherAmount: "",
      stoneAmount: "",
    });
  };




  const rateDED = [5.00, 6.00, 4.00, 10.00, 0.10, 1.00, 2.00, 3.00, 8.00, 7.00, 0.50, 9.00]
  const purity = ["24KT", "22KT", "18KT", "14KT"]
  const productSection = ["OLD GOLD", "KJ OLD GOLD", "CANDERE COIN", "B2B OLD GOLD COIN", "KJ OLD GOLD COIN", "DHAN REKHA SCHEME-OG", "DHAN REKHA SCHEME-KJ OG", "CANDERE OG"]
  const productOriginSource = ["JUELIS", "CANDERE", "OTHER"]

  const handleDelete = (indexToDelete) => {
    const filtered = products.filter((_, i) => i !== indexToDelete);
    setProducts(filtered);
  };

  const handleSave = () => {

    if (products.length === 0) {
      toast.warn("Please add at least one product before saving.");
      return;

    }

    let payload = {
      "customer": userData?.userName,
      "company": selectedStore?.name,
      "posting_date": new Date().toISOString().split('T')[0],
      productDetails: products?.map((item) => {
        return {
          "product_origin_source": item?.productOrigin,
          "hall_mark": item?.hallmark ? 1 : 0,
          "rate_deduction": item?.rateDeduction,
          "rate_deduction_amount": isNaN(item?.rateDeductionAmount) ? "" : item?.rateDeductionAmount,
          "rate_ded_amountgram": isNaN(item?.rateDedAmountPerGram) ? "" : item?.rateDedAmountPerGram,
          "rate_before_deduction": isNaN(item?.rateBeforeDeduction) ? "" : item?.rateBeforeDeduction,
          "rate_after_deduction": isNaN(item?.rateAfterDeduction) ? "" : item?.rateAfterDeduction,
          "gold_rate_details": "",
          "metal_info": item?.metalInfo,
          "other_info": item?.otherInfo,
          "stone_info": item?.stoneInfo,
          "total_before_rate_deduction": item?.totalBeforeRateDeduction,
          "rate_deduction_total": item?.rateDeductionTotal,
          "current_gold_rate": "",
          "total_net_weight": "",
          "total_amount": item?.total,
          "total_depreciate_wieght": item?.depreciatedWeight,
          // "customer_address": "SH-Shipping-157",
          // "address_display": "gfdtyr<br>\nKottayam<br>\n686001<br>India<br>\n<br>\nPhone: 12345678<br>Email: thankaraj.j@candere.com<br>",
          // "company_address_name": "billing-Billing",
          // "company_gstin": null,
          // "company_address": "2/7 saami cootage<br>\nMumbai<br>Mumbai<br>\nMaharastra<br>876543<br>India<br>\n<br>\nPhone: 876543219<br>Email: Ena@gmail.com<br>",
          "invoice_number": item?.invoiceNo,
          "product_section": item?.productSection,
          "product_group": item?.group,
          "description": item?.productDescription,
          "gross": item?.grossInfo,
          "hsn_code": "0102",
          "gold_purity": item?.purity,
          "purity_percentage": item?.purity,
          "stone_weight": 53.0,
          "depreciate_weight": item?.depreciatedWeight,
          "net_weight": isNaN(item?.netWtAfDepre) ? "" : item?.netWtAfDepre,
          "cash_rate_after_depreciate": isNaN(item?.rateAfterDeduction) ? "" : item?.rateAfterDeduction,
          "amount": "",
          "gross_info": item?.grossInfo,
          grossAmount: item?.grossAmount,
          metalAmount: item?.metalAmount,
          otherAmount: item?.otherAmount,
          stoneAmount: item?.stoneAmount,
          machCalcDepreWt: item?.machCalcDepreWt,
          machCalcPurity: item?.machCalcPurity,
          dealloyingCharge: item?.dealloyingCharge,
          image1: photo,
          old_gold_before_melting: item?.old_gold_before_melting,
          old_gold_after_melting: item?.old_gold_after_melting,
        }
      })
    }

    console.log(payload, "payloa----------d");


    try {
      let response = createOldGold(payload);
      console.log(response, "response");
      toast.success("Data saved successfully");
      setProducts([]);
    } catch (error) {
      console.log(error, "error");
      toast.error("Error in saving data");
    }
  }

  const getgoldrate = async () => {
    try {
      let response = await GetGoldRate();
      setGoldRate(response)
      console.log(response, "response-----");
    } catch (error) {
      console.log(error, "error");
    }
  }

  const purityMap = {
    "24KT": "karat_24(995)",  // Can use karat_24(995) or karat_24(999) based on your choice
    "22KT": "karat_22",
    "18KT": "karat_18",
    "14KT": "karat_14",
    "10KT": "karat_10"  // Assuming "karat_10" exists or you can add it to your data
  };

  // Function to match purity
  function matchKaratPurity(purity) {
    let karatKey = purityMap[purity];
    console.log(karatKey, purity, goldRate, "karatKey");

    if (karatKey) {
      return goldRate.find(entry => entry[karatKey])?.[karatKey];
    } else {
      return null;  // No match found
    }
  }

  useEffect(() => {
    getgoldrate();
    if (id) {
      GetOldGoldData()
    }
  }, [id]);


  const GetOldGoldData = async () => {
    setDataLoading(true)
    try {
      let response = await GetOldGoldList({
        docname: id
      });
      console.log(response?.data?.message, response?.data?.message?.doc, "response-----");
      if (response?.data?.message) {
        setProducts([{
          productOrigin: response?.data?.message?.doc?.product_origin_source,
          invoiceNo: '',
          group: response?.data?.message?.doc?.product_group,
          productSection: response?.data?.message?.doc?.product_section,
          productDescription: response?.data?.message?.doc?.old_gold_item_details[0]?.description,
          hallmark: response?.data?.message?.doc?.hall_mark === 1 ? true : false,
          purity: response?.data?.message?.doc?.old_gold_item_details[0]?.gold_purity,
          machCalcPurity: '',
          grossInfo: response?.data?.message?.doc?.old_gold_item_details[0]?.gross_info,
          metalInfo: response?.data?.message?.doc?.metal_info,
          otherInfo: response?.data?.message?.doc?.other_info,
          stoneInfo: response?.data?.message?.doc?.stone_info,
          machCalcDepreWt: '',
          depreciatedWeight: response?.data?.message?.doc?.total_depreciate_wieght,
          netWtAfDepre: response?.data?.message?.doc?.old_gold_item_details[0]?.net_weight,
          rateDeduction: response?.data?.message?.doc?.rate_deduction,
          rateDeductionAmount: response?.data?.message?.doc?.rate_deduction_amount,
          rateDedAmountPerGram: response?.data?.message?.doc?.rate_ded_amountgram,
          rateBeforeDeduction: response?.data?.message?.doc?.rate_before_deduction,
          rateAfterDeduction: response?.data?.message?.doc?.rate_after_deduction,
          totalBeforeRateDeduction: response?.data?.message?.doc?.total_before_rate_deduction,
          rateDeductionTotal: response?.data?.message?.doc?.rate_deduction_total,
          total: response?.data?.message?.doc?.total_amount,
          grossAmount: response?.data?.message?.doc?.grossAmount,
          metalAmount: response?.data?.message?.doc?.metalAmount,
          otherAmount: response?.data?.message?.doc?.otherAmount,
          stoneAmount: response?.data?.message?.doc?.stoneAmount,
          pdf: response?.data?.message?.pdf_url,
          old_gold_after_melting: response?.data?.message?.doc?.after_melting_image_url,
          old_gold_before_melting: response?.data?.message?.doc?.before_melting_image_url
        }])

        setFormData({
          productOrigin: response?.data?.message?.doc?.product_origin_source,
          invoiceNo: '',
          group: response?.data?.message?.doc?.product_group,
          productSection: response?.data?.message?.doc?.product_section,
          productDescription: response?.data?.message?.doc?.old_gold_item_details[0]?.description,
          hallmark: response?.data?.message?.doc?.hall_mark === 1 ? true : false,
          purity: response?.data?.message?.doc?.old_gold_item_details[0]?.gold_purity,
          machCalcPurity: '',
          grossInfo: response?.data?.message?.doc?.old_gold_item_details[0]?.gross_info,
          metalInfo: response?.data?.message?.doc?.metal_info,
          otherInfo: response?.data?.message?.doc?.other_info,
          stoneInfo: response?.data?.message?.doc?.stone_info,
          machCalcDepreWt: '',
          depreciatedWeight: response?.data?.message?.doc?.total_depreciate_wieght,
          netWtAfDepre: response?.data?.message?.doc?.old_gold_item_details[0]?.net_weight,
          rateDeduction: response?.data?.message?.doc?.rate_deduction,
          rateDeductionAmount: response?.data?.message?.doc?.rate_deduction_amount,
          rateDedAmountPerGram: response?.data?.message?.doc?.rate_ded_amountgram,
          rateBeforeDeduction: response?.data?.message?.doc?.rate_before_deduction,
          rateAfterDeduction: response?.data?.message?.doc?.rate_after_deduction,
          totalBeforeRateDeduction: response?.data?.message?.doc?.total_before_rate_deduction,
          rateDeductionTotal: response?.data?.message?.doc?.rate_deduction_total,
          total: response?.data?.message?.doc?.total_amount,
          grossAmount: response?.data?.message?.doc?.grossAmount,
          metalAmount: response?.data?.message?.doc?.metalAmount,
          otherAmount: response?.data?.message?.doc?.otherAmount,
          stoneAmount: response?.data?.message?.doc?.stoneAmount,
          pdf: response?.data?.message?.pdf_url,
          old_gold_after_melting: response?.data?.message?.doc?.after_melting_image_url,
          old_gold_before_melting: response?.data?.message?.doc?.before_melting_image_url
        })
      }
      setDataLoading(false)

    } catch (error) {
      setDataLoading(false)
      console.log(error, "error");
    }
  }


  useEffect(() => {

    if (id) {
      return;
    }

    const currentGoldRate = matchKaratPurity(formData.purity);

    console.log(currentGoldRate, "matchedKarat");
    const metal = parseFloat(formData.metalInfo) || 0;
    const other = parseFloat(formData.otherInfo) || 0;
    const stone = parseFloat(formData.stoneInfo) || 0;

    let metalAmount = parseFloat(currentGoldRate?.price_per_gram) * parseFloat(formData?.metalInfo);
    const otherAmount = parseFloat(formData.otherAmount) || 0;
    const stoneAmount = parseFloat(formData.stoneAmount) || 0;


    const calculatedGross = metal + other + stone;
    const calculatedGrossAmount = metalAmount + otherAmount + stoneAmount;

    const net_wt_af_dep = parseFloat(formData?.metalInfo) - parseFloat(formData?.depreciatedWeight);

    // const rateDeductionAmount = parseFloat(formData?.depreciatedWeight) * parseFloat(metalAmount);
    const rateDeductionAmount = calculateRateDeductionAmount(formData?.rateDeduction, parseFloat(currentGoldRate?.price_per_gram))

    const rateDeductionPerAmountPerGram = parseFloat(rateDeductionAmount) / parseFloat(formData?.metalInfo);
    const rateAfterDeduction = calculateRateAfterDeduction(currentGoldRate?.price_per_gram, formData?.rateDeduction)
    const temp = parseFloat(currentGoldRate?.price_per_gram) * parseFloat(formData?.depreciatedWeight)
    console.log(temp, parseFloat(calculatedGross.toFixed(3)), parseFloat(temp), "temp");

    const totalBeforeRateDeduction = formData?.depreciatedWeight ? parseFloat(calculatedGrossAmount.toFixed(3)) - parseFloat(temp)
      : parseFloat(rateDeductionAmount.toFixed(3))

    const rate_deducation_total = calculateRateDeductionTotal(totalBeforeRateDeduction.toFixed(3), formData?.rateDeduction)

    const total = parseFloat(totalBeforeRateDeduction) - parseFloat(rate_deducation_total.toFixed(3))

    // setFormData((prev) => ({
    //   ...prev,
    //   grossInfo: calculatedGross.toFixed(3),
    //   grossAmount: calculatedGrossAmount.toFixed(3),
    //   metalAmount: metalAmount.toFixed(3),
    //   netWtAfDepre: net_wt_af_dep.toFixed(3),
    //   rateDeductionAmount: rateDeductionAmount.toFixed(3),
    //   rateDedAmountPerGram: rateDeductionAmount.toFixed(3),
    //   rateAfterDeduction: formData?.rateDeduction ? rateAfterDeduction.toFixed(3) : 0,
    //   totalBeforeRateDeduction: totalBeforeRateDeduction,
    //   rateDeductionTotal: rate_deducation_total.toFixed(3),
    //   rateBeforeDeduction: currentGoldRate?.price_per_gram,
    //   total: total.toFixed(3),
    // }));

    setFormData((prev) => ({
      ...prev,
      grossInfo: calculatedGross.toFixed(3),
      grossAmount: calculatedGrossAmount.toFixed(3),
      metalAmount: metalAmount.toFixed(3),
      netWtAfDepre: Math.max(0, net_wt_af_dep).toFixed(3),
      rateDeductionAmount: Math.max(0, rateDeductionAmount).toFixed(3),
      rateDedAmountPerGram: Math.max(0, rateDeductionAmount).toFixed(3),
      rateAfterDeduction: formData?.rateDeduction ? Math.max(0, rateAfterDeduction).toFixed(3) : 0,
      totalBeforeRateDeduction: Math.max(0, totalBeforeRateDeduction),
      rateDeductionTotal: Math.max(0, rate_deducation_total).toFixed(3),
      rateBeforeDeduction: currentGoldRate?.price_per_gram,
      total: Math.max(0, total).toFixed(3),
    }));

  }, [formData.metalInfo, formData.otherInfo, formData.stoneInfo, formData.metalAmount, formData.otherAmount, formData.stoneAmount, formData?.purity, goldRate, formData?.metalInfo, formData?.rateDeduction, formData?.depreciatedWeight, formData?.purity]);


  function calculateRateAfterDeduction(rateBeforeDeduction, rateDeductionPercent) {
    // Calculate the deduction amount
    const deductionAmount = rateBeforeDeduction * (rateDeductionPercent / 100);

    // Calculate the rate after deduction
    const rateAfterDeduction = rateBeforeDeduction - deductionAmount;

    return rateAfterDeduction;
  }

  function calculateRateDeductionTotal(totalBeforeDeduction, rateDeductionPercent) {
    // Calculate the rate deduction total
    const rateDeductionTotal = totalBeforeDeduction * (rateDeductionPercent / 100);

    return rateDeductionTotal;
  }


  function calculateRateDeductionAmount(rateDeductionPercent, currentMarketValue) {
    const deductionAmount = (rateDeductionPercent / 100) * currentMarketValue;
    return deductionAmount;
  }

  console.log(photo, "ndekjndnjdbn");
  // const openImageViewer = (imgSrc) => {
  //   setImageToView(imgSrc);
  //   setIsOpen(true);
  // };
  // const closeImageViewer = () => {
  //   setIsOpen(false);
  //   setImageToView(null);
  // };


  return (
    <div className="old-purchase-container">
      <div className="header">

        <div className="" style={{
          display: "flex",
          gap: "10px",
        }}>
          <ChevronLeft
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/categories")
            }}
          />

          <h2>Old Purchase Estimation</h2>
        </div>
        <button>
          <Link to="/oldgold/list">
            Old Purchase Estimate List
          </Link>
        </button>
      </div>
      {
        dataLoading ? <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f0f0f0',
          flexDirection: 'column'
        }}>
          <CustomLoader />
        </div> : <div>
          <div className="records-section">
            <h4>Recent created Records</h4>
            <div style={{
              height: "30vh"
            }}>

              <Table records={products} id={id} handleDelete={handleDelete} handleEdit={handleEdit} />
            </div>

          </div>
          <div className="">
            <div className="record-form-container">
              <h3>Select Record Details</h3>
              <div className="product-input-form">
                {/* Product Origin Source */}
                <div className="form-group">
                  <label style={{ display: "flex", gap: "2px" }} htmlFor="product-origin">
                    Product Origin Source <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    id="product-origin"
                    disabled={!!id}
                    name="productOrigin"
                    value={formData.productOrigin}
                    onChange={handleChange}
                  >
                    <option value="" disabled hidden>
                      Select Product Origin
                    </option>
                    {productOriginSource.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Invoice No */}
                <div className="form-group">
                  <label>Invoice No</label>
                  <input
                    type="text"
                    name="invoiceNo"
                    placeholder="Enter Invoice No"
                    value={formData.invoiceNo}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Group */}
                <div className="form-group">
                  <label>Group</label>
                  <select
                    name="group"
                    value={formData.group}
                    disabled={!!id}
                    onChange={handleChange}

                  >
                    <option value="" disabled hidden>
                      Select Group
                    </option>
                    <option value="OLD GOLD">OLD GOLD</option>
                  </select>
                </div>

                {/* Product Section */}
                <div className="form-group">
                  <label style={{ display: "flex", gap: "2px" }}>
                    Product Section <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    name="productSection"
                    disabled={!!id}
                    value={formData.productSection}
                    onChange={handleChange}
                  >
                    <option value="" disabled hidden>
                      Select Product Section
                    </option>
                    {productSection.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Product Description */}
                <div className="form-group">
                  <label>Product Description</label>
                  <input
                    type="text"
                    name="productDescription"
                    placeholder="OG, COIN etc."
                    value={formData.productDescription}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Hallmark */}
                <div className="form-item checkbox">
                  <input
                    type="checkbox"
                    name="hallmark"
                    checked={formData.hallmark}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                  <label>Hallmark</label>
                </div>

                {/* Purity */}
                <div className="form-group">
                  <label style={{ display: "flex", gap: "2px" }}>
                    Purity <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    disabled={!!id}
                    name="purity"
                    value={formData.purity}
                    onChange={handleChange}
                  >
                    <option value="" disabled hidden>
                      Select Purity
                    </option>
                    {purity.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Mach. Calc. Purity */}
                <div className="form-group">
                  <label>Mach. Calc. Purity</label>
                  <input
                    type="number"
                    name="machCalcPurity"
                    value={formData.machCalcPurity}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Gross Info */}
                <div className="form-group">
                  <label>Gross Info</label>
                  <input
                    type="number"
                    name="grossInfo"
                    placeholder="Enter in Gram"
                    value={formData.grossInfo}
                    onChange={handleChange}
                    disabled
                  />
                </div>

                {/* Gross Amount */}
                <div className="form-group">
                  <label>Gross Amount</label>
                  <input
                    type="number"
                    name="grossAmount"
                    placeholder="Amount"
                    value={formData?.grossAmount}
                    onChange={handleChange}
                    disabled
                  />
                </div>

                {/* Metal Info */}
                <div className="form-group">
                  <label style={{ display: "flex", gap: "2px" }}>
                    Metal Info <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="metalInfo"
                    placeholder="Enter in Gram"
                    value={formData.metalInfo}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Metal Amount */}
                <div className="form-group">
                  <label>Metal Amount</label>
                  <input
                    type="number"
                    name="metalAmount"
                    placeholder="Amount"
                    value={formData.metalAmount}
                    onChange={handleChange}
                    disabled={!!id}
                    readOnly
                  />
                </div>

                {/* Other Info */}
                <div className="form-group">
                  <label>Other Info</label>
                  <input
                    type="text"
                    name="otherInfo"
                    placeholder="Enter in Gram"
                    value={formData.otherInfo}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Other Amount */}
                <div className="form-group">
                  <label>Other Amount</label>
                  <input
                    type="number"
                    name="otherAmount"
                    placeholder="Amount"
                    value={formData.otherAmount}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Stone Info */}
                <div className="form-group">
                  <label>Stone Info</label>
                  <input
                    type="number"
                    name="stoneInfo"
                    placeholder="Enter in Gram"
                    value={formData.stoneInfo}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Stone Amount */}
                <div className="form-group">
                  <label>Stone Amount</label>
                  <input
                    type="number"
                    name="stoneAmount"
                    placeholder="Amount"
                    value={formData.stoneAmount}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Mach. Calc. Depre. Wt */}
                <div className="form-group">
                  <label>Mach. Calc. Depre. Wt</label>
                  <input
                    type="number"
                    name="machCalcDepreWt"
                    value={formData.machCalcDepreWt}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Depreciated Weight */}
                <div className="form-group">
                  <label>Depreciated Weight</label>
                  <input
                    type="number"
                    name="depreciatedWeight"
                    value={formData.depreciatedWeight}
                    onChange={handleChange}
                    disabled={!!id}
                  />
                </div>

                {/* Net Wt. Af. Depre. */}
                <div className="form-group">
                  <label>Net Wt. Af. Depre.</label>
                  <input
                    type="number"
                    name="netWtAfDepre"
                    value={formData.netWtAfDepre}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Rate Deduction % */}
                <div className="form-group">
                  <label>Rate Deduction %</label>
                  <select
                    disabled={!!id}
                    name="rateDeduction"
                    value={formData.rateDeduction}
                    onChange={handleChange}
                  >
                    <option value="" disabled hidden>
                      Select Rate Deduction
                    </option>
                    {rateDED.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Rate Deduction Amount */}
                <div className="form-group">
                  <label>Rate Deduction Amount</label>
                  <input
                    type="number"
                    name="rateDeductionAmount"
                    value={formData.rateDeductionAmount}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Rate Ded. Amount/Gram */}
                <div className="form-group">
                  <label>Rate Ded. Amount/Gram</label>
                  <input
                    type="number"
                    name="rateDedAmountPerGram"
                    value={formData.rateDedAmountPerGram}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Rate Before Deduction */}
                <div className="form-group">
                  <label>Rate Before Deduction</label>
                  <input
                    type="number"
                    name="rateBeforeDeduction"
                    value={formData.rateBeforeDeduction}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Rate After Deduction */}
                <div className="form-group">
                  <label>Rate After Deduction</label>
                  <input
                    type="number"
                    name="rateAfterDeduction"
                    value={formData.rateAfterDeduction}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Total Before Rate Deduction */}
                <div className="form-group">
                  <label>Total Before Rate Deduction</label>
                  <input
                    type="number"
                    name="totalBeforeRateDeduction"
                    value={formData.totalBeforeRateDeduction}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Rate Deduction Total */}
                <div className="form-group">
                  <label>Rate Deduction Total</label>
                  <input
                    type="number"
                    name="rateDeductionTotal"
                    value={formData.rateDeductionTotal}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>

                {/* Total */}
                <div className="form-group">
                  <label>Total</label>
                  <input
                    type="number"
                    name="total"
                    value={formData.total}
                    onChange={handleChange}
                    readOnly
                    disabled={!!id}
                  />
                </div>
                <div className="form-group">
                  <label>Before melting</label>
                  <div className="" style={{
                    display: "flex",
                    gap: "20px",
                    // justifyContent:"center",
                    alignItems: "center"

                  }}>



                    {formData?.old_gold_before_melting ? (
                      <img
                        src={formData?.old_gold_before_melting}
                        alt="before melting"
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (id) {
                            return
                          }
                          setActive_old_gold("before_melting")
                          setPhoto(formData?.old_gold_before_melting)
                          setIsOpen(true)
                        }}
                      // onClick={() => openImageViewer(formData.old_gold_before_melting)}
                      />
                    ) : <Camera className="" style={{
                      cursor: "pointer",
                    }} size={30}
                      onClick={() => {
                        if (id) {
                          return
                        }
                        setActive_old_gold("before_melting")
                        setIsOpen(true)
                      }}
                    />}
                  </div>
                </div>
                <div className="form-group">
                  <label>After Melting</label>
                  <div className="" style={{
                    display: "flex",
                    gap: "20px",
                    // justifyContent:"center",
                    alignItems: "center"

                  }}>



                    {formData?.old_gold_after_melting ? (
                      <img
                        src={formData?.old_gold_after_melting}
                        alt="before melting"
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (id) {
                            return
                          }
                          setActive_old_gold("after_melting")
                          setPhoto(formData?.old_gold_after_melting)
                          setIsOpen(true)
                        }}
                      // onClick={() => openImageViewer(formData.old_gold_before_melting)}
                      />
                    ) : <Camera className="" style={{
                      cursor: "pointer",
                    }} size={30}
                      onClick={() => {
                        if (id) {
                          return
                        }
                        setActive_old_gold("after_melting")
                        setIsOpen(true)
                      }}
                    />}
                  </div>
                </div>
              </div>
              {!id && <div className="button-group">
                <button disabled={!!id} onClick={handleAdd}>{editIndex !== null ? 'Update' : 'Add'}</button>
                <button
                  onClick={() => {
                    setFormData({
                      productOrigin: '',
                      invoiceNo: '',
                      group: '',
                      productSection: '',
                      productDescription: '',
                      hallmark: false,
                      purity: "24KT",
                      machCalcPurity: '',
                      grossInfo: '',
                      metalInfo: '',
                      otherInfo: '', grossAmount: "",
                      metalAmount: "",
                      otherAmount: "",
                      stoneAmount: "",
                      stoneInfo: '',
                      machCalcDepreWt: '',
                      depreciatedWeight: '',
                      netWtAfDepre: '',
                      dealloyingCharge: '0%',
                      dealloyingChargeAmount: '',
                      handlingCharge: '0%',
                      handlingChargeAmount: '',
                      rateDeduction: '0%',
                      rateDeductionAmount: '',
                      rateDedAmountPerGram: '',
                      rateBeforeDeduction: '',
                      rateAfterDeduction: '',
                      totalBeforeRateDeduction: '',
                      rateDeductionTotal: '',
                      total: '',
                      old_gold_after_melting: "",
                      old_gold_before_melting: "",
                    })
                    setProducts([])
                  }}
                  disabled={!!id}
                >Refresh</button>
                {/* <button>Print</button> */}
                {/* <button>Delete</button> */}
                <button onClick={handleSave} disabled={!!id} >Save</button>
                {/* <button>Cancel</button> */}

              </div>}
            </div>
          </div>
          <CustomModal isOpen={isOpen} title={""} onClose={() => setIsOpen(false)}>
            <div style={{ textAlign: 'center' }}>
              <h3>Capture Photo</h3>
              <p>Please capture the photo of the product.</p>

              <CameraCapture
                photo={photo}
                setPhoto={(item) => {
                  if (active_old_gold === "before_melting") {
                    setFormData((prev) => ({
                      ...prev,
                      old_gold_before_melting: item,
                    }));
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      old_gold_after_melting: item,
                    }));
                  }

                  setPhoto(item);
                }}
                handleConfirmPhoto={() => {
                  setIsOpen(false);
                  setActive_old_gold("")
                  setPhoto("");

                }}
              />

              {photo && <p style={{ marginTop: '10px', color: 'green' }}>Photo captured successfully!</p>}
            </div>
          </CustomModal>
        </div>
      }



    </div >
  );
};

export default OldPurchaseEstimation;
